import { render, staticRenderFns } from "./xxzykcszal.vue?vue&type=template&id=ad4e48d0&scoped=true&"
import script from "./xxzykcszal.vue?vue&type=script&lang=js&"
export * from "./xxzykcszal.vue?vue&type=script&lang=js&"
import style0 from "./xxzykcszal.vue?vue&type=style&index=0&id=ad4e48d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4e48d0",
  null
  
)

export default component.exports